import styled from 'styled-components'
import { themeGet } from '@style'

const Heighlight = styled.span`
  color: ${themeGet('colors.burlyWood')};
  font-weight: 700;
  background-color: ${themeGet('colors.green.100')};
  padding-left: ${themeGet('space.1')};
  padding-right: ${themeGet('space.1')};
  border-radius: 5px;
`

export { Heighlight }
